export default __webpack_public_path__ + "static/media/pet-pandemonium.dcd342bb.png";